var React = require('react');

function Rotate (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.193 5H8v2H1V0h2v3.27C4.725 1.183 7.196 0 10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10h2a8 8 0 108-8C7.606 2 5.554 3.079 4.193 5z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.193 5H8v2H1V0h2v3.27C4.725 1.183 7.196 0 10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10h2a8 8 0 108-8C7.606 2 5.554 3.079 4.193 5z","fill":"currentColor","key":1})]);
}

Rotate.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Rotate;

Rotate.default = Rotate;
